// ─── Tipos de día ────────────────────────────────────────────────────────────

/** Clave de día usada internamente en la UI (español) */
export type UiDayKey = 'lunes' | 'martes' | 'miercoles' | 'jueves' | 'viernes' | 'sabado' | 'domingo';

/** Clave de día usada por el API (inglés) */
export type ApiDayKey = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export const UI_TO_API_DAY: Record<UiDayKey, ApiDayKey> = {
  lunes: 'monday', martes: 'tuesday', miercoles: 'wednesday',
  jueves: 'thursday', viernes: 'friday', sabado: 'saturday', domingo: 'sunday'
};

export const API_TO_UI_DAY: Record<ApiDayKey, UiDayKey> = {
  monday: 'lunes', tuesday: 'martes', wednesday: 'miercoles',
  thursday: 'jueves', friday: 'viernes', saturday: 'sabado', sunday: 'domingo'
};

// ─── Interfaces de referencia anidada ────────────────────────────────────────

export interface PriceTimezone {
  id: number;
  name: string;
  gmt_offset: string;
}

export interface PriceNestedRef {
  id: number;
  name: string;
}

// ─── Respuesta GetAll ─────────────────────────────────────────────────────────

/** Ítem de la lista paginada (GET /v1/prices) */
export interface Price {
  id: number;
  name: string;
  timezone: PriceTimezone;
  commercial_zone: PriceNestedRef;
  commercial_condition: PriceNestedRef;
  validity_start_date: string;
  validity_end_date: string | null;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
  created_by?: number;
  updated_by?: number;
  // Campos aplanados para mostrar en tabla (calculados en el servicio)
  timezone_name?: string;
  commercial_zone_name?: string;
  commercial_condition_name?: string;
  validity_display?: string;
}

// ─── Respuesta GetById ────────────────────────────────────────────────────────

export interface PriceScheduleDetail {
  start_time: string; // "HH:MM:SS"
  end_time: string;   // "HH:MM:SS"
  prices: Record<string, number>;
}

/** Detalle completo de un precio (GET /v1/prices/{id}) */
export interface PriceDetail {
  id: number;
  name: string;
  timezone_id: number;
  commercial_zone_id: number;
  commercial_condition_id: number;
  validity_start_date: string;
  validity_end_date: string | null;
  is_active: boolean;
  tax_percentage: number;
  schedule: PriceScheduleDetail[];
  created_at?: string;
  updated_at?: string;
  created_by?: number;
  updated_by?: number;
}

// ─── Datos del formulario (POST / PUT) ───────────────────────────────────────

export interface PriceScheduleFormItem {
  start_time: string;
  end_time: string;
  prices: Record<ApiDayKey, number>;
}

export interface PriceFormData {
  name: string;
  timezone_id: number;
  commercial_zone_id: number;
  commercial_condition_id: number;
  validity_start_date: string;
  validity_end_date: string | null;
  tax_percentage: number;
  is_active: boolean;
  confirm_gaps: boolean;
  schedule: PriceScheduleFormItem[];
}
